<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.go(-1)" />

                <div class="header-block location-center">
                    <div class="barrier">
                        <img style="width: 112px" src="@/assets/icons/specials/left-block-header.svg" alt="">
                    </div>
                    <div class="label">
                        {{ $t('selectedTariff.header') }}
                    </div>
                    <div class="barrier">
                        <img style="width: 112px" src="@/assets/icons/specials/right-block-header.svg" alt="">
                    </div>
                </div>

                <div>
                    <div class="tariff-panel mt-28">
                        <div class="tariff-panel__background">
                            <img src="@/assets/icons/specials/tariff-panel-background.svg" alt="">
                        </div>
                        <div class="multi-label">
                            <div class="text-panel">
                                <div class="text-panel__lt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__lb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>

                                <div class="text-panel__background">

                                </div>

                                <div class="text-panel__text">
                                    {{ store.tariffObject.name }}
                                </div>

                            </div>
                            <div class="text-panel">
                                <div class="text-panel__lt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__lb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rb-angle">
                                    <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>
                                <div class="text-panel__rt-angle">
                                    <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                        <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    </svg>
                                </div>

                                <div class="text-panel__background">

                                </div>

                                <div class="text-panel__multi-text">
                                    <div v-if="store.tariffType === 'internet'">{{ store.tariffObject.id_down }}<span class="micro-text"> {{ $t('selectedTariff.speed') }}</span></div>
                                    <div v-if="store.tariffType === 'tv'">{{ store.tariffObject.channels.length }}<span class="micro-text"> {{ $t('selectedTariff.channels') }}</span></div>
                                    <div>{{ store.tariffObject.summa }}<span class="micro-text"> {{ $t('selectedTariff.currency') }}/<span v-if="store.tariffObject.name !== 'Day'">{{ $t('selectedTariff.priceMonth') }}</span><span v-else>{{ $t('selectedTariff.priceDay') }}</span>
                                    </span></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adaptation-block__column desktop-mt-45">
                <div class="select-container">
                    <uzhnet-multi-select :label="$t('selectedTariff.selectPeriod')" :options="selectedOptions" v-model="selectedOption"/>
                </div>

                <div class="footer-wrapper">
                    <div v-if="selectedOption != 0" class="selected-tariff__footer">
                        <uzhnet-button @click="$router.push('/payment-process')" :label="$t('selectedTariff.payButton')"  style="max-width: 480px; width: 95%"/>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ref, watch } from 'vue';

import { useMainStore } from '@/store/mainStore'

import { useI18n } from 'vue-i18n'

export default {
    name: "SelectedTariff",

    setup() {
        const { t } = useI18n()

        const store = useMainStore()

        const selectedOption = ref(0);

        const monthOptions = [
            { value: 1, label: '1 ' + t('selectedTariff.oneMonth') },
            { value: 2, label: '2 ' + t('selectedTariff.moreMonthes') },
            { value: 3, label: '3 ' + t('selectedTariff.moreMonthes') },
            { value: 4, label: '4 ' + t('selectedTariff.moreMonthes') },
            { value: 5, label: '5 ' + t('selectedTariff.moreMonthes') },
            { value: 6, label: '6 ' + t('selectedTariff.moreMonthes') },
            { value: 7, label: '7 ' + t('selectedTariff.moreMonthes') },
            { value: 8, label: '8 ' + t('selectedTariff.moreMonthes') },
            { value: 9, label: '9 ' + t('selectedTariff.moreMonthes') },
            { value: 10, label: '10 ' + t('selectedTariff.moreMonthes') },
            { value: 11, label: '11 ' + t('selectedTariff.moreMonthes') },
            { value: 12, label: '12 ' + t('selectedTariff.moreMonthes') }
        ]
        const dayOptions = [
            { value: 1, label: '1 ' + t('selectedTariff.oneDay') },
            { value: 2, label: '2 ' + t('selectedTariff.moreDays') },
            { value: 3, label: '3 ' + t('selectedTariff.moreDays') },
            { value: 4, label: '4 ' + t('selectedTariff.moreDays') },
            { value: 5, label: '5 ' + t('selectedTariff.moreDays') },
            { value: 6, label: '6 ' + t('selectedTariff.moreDays') },
            { value: 7, label: '7 ' + t('selectedTariff.moreDays') }
        ]

        const selectedOptions = ref(store.tariffObject.name === 'Day' ? dayOptions : monthOptions);

        watch(selectedOption, (newValue) => {
            store.setCurrentTariffPeriod(newValue);
        });

        return {
            selectedOption,
            store,

            selectedOptions
        }
    }
}
</script>
<style lang="scss">
$corner: 20px;
$dark: #1B1C22;

    .selected-tariff {
        &__footer {
            bottom: 30px;
        }

    }

    .select-container {
        padding: 0 20px;
        margin-top: 20px;
    }
</style>
